import React from "react";
import LogOutIcon from "../assets/logout.svg";
import { useNavigate } from "react-router-dom";

export const SignOutButton = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    navigate("/logout");
  };

  return (
    <button type="button" onClick={handleLogout} className="">
      <img src={LogOutIcon} alt="Logout" width={15} />
    </button>
  );
};
